import { Badge } from "@mantine/core";

export type GetTransactionsParams = {
  Count?: number;
  /** @format int32 */
  Skip?: number;
  Term?: string;
};

export const TransactionStatusConvertor = {
  0: <Badge color="red">پرداخت ناموفق</Badge>,
  1: <Badge color="red">ناموفق </Badge>,
  2: <Badge color="green">موفق </Badge>,
  3: <Badge color="yellow"> بازگشت داده شده </Badge>,
};
